/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ADDED_EXPIRATION_YEARS, CARD_TYPES } from 'constants/payment'
import { getYearsDuration } from 'utils/date'

export const getMonthOptions = () => {
  const options = []
  for (let i = 1; i <= 12; i++) {
    options.push({
      label: i,
      value: i,
    })
  }
  return options
}

export const getYearOptions = () => {
  const options = []
  const [start, end] = getYearsDuration(ADDED_EXPIRATION_YEARS)
  for (let i = start; i <= end; i++) {
    options.push({
      label: i,
      value: i.toString().substr(2),
    })
  }
  return options
}

export const getCardTypeByNumber = (cardNumber: string): CARD_TYPES | null => {
  if (!cardNumber) {
    return null
  }

  if (cardNumber.startsWith('4')) {
    return CARD_TYPES.visa
  }

  if (cardNumber.startsWith('30') || cardNumber.startsWith('36') || cardNumber.startsWith('38')) {
    return CARD_TYPES.dc
  }

  if (cardNumber.startsWith('34') || cardNumber.startsWith('37')) {
    return CARD_TYPES.amex
  }

  if (
    cardNumber.startsWith('60') ||
    cardNumber.startsWith('62') ||
    cardNumber.startsWith('64') ||
    cardNumber.startsWith('65')
  ) {
    return CARD_TYPES.disc
  }

  if (
    cardNumber.startsWith('51') ||
    cardNumber.startsWith('52') ||
    cardNumber.startsWith('53') ||
    cardNumber.startsWith('54') ||
    cardNumber.startsWith('55')
  ) {
    return CARD_TYPES.mc
  }

  return CARD_TYPES.custom
}
